import { FormattedMessage } from 'react-intl';
import { BOOKABLE_APPLICATION_STATES, type Schedule } from '../../types';

const explains = (schedule: Schedule) =>
  !(BOOKABLE_APPLICATION_STATES as readonly string[]).includes(schedule.application_state);

interface Props {
  schedule: Schedule;
}

export default function ApplicationStateLabel({ schedule }: Props) {
  const id = explains(schedule)
    ? `schedule.applicationState.${schedule.application_state}`
    : 'schedule.applicationState.unavailable';

  return (
    <span className="mt-0.5 block text-xs text-amber-700">
      <FormattedMessage id={id} defaultMessage="This application isn't available for booking right now." />
    </span>
  );
}
